import axios from 'axios';
import setDuplicatePartner from './redux/actions/metaActions';
import { accessTokenFromUrl } from './utils';

const blankError = 'Required';

export const firstPageValidations = (values) => {
  const formErrors = {};
  const isUS = values.country === 'United States';
  if (!values.name) formErrors.name = [blankError];
  if (!values.legal_name) formErrors.legal_name = [blankError];
  if (!values.business_phone) formErrors.business_phone = [blankError];
  if (!values.entity_type) formErrors.entity_type = [blankError];
  if (!values.country) formErrors.country = [blankError];
  if (isUS) {
    if (!values.state) formErrors.state = [blankError];
    if (!values.zip_code) {
      formErrors.zip_code = [blankError];
    } else {
      const zipCodeLength = String(values.zip_code).length;
      if (zipCodeLength !== 5) formErrors.zip_code = ['must be five digits'];
    }
  }
  if (!values.address_1) formErrors.address_1 = [blankError];
  if (!values.primary_contact_name)
    formErrors.primary_contact_name = [blankError];
  if (!values.primary_contact_email)
    formErrors.primary_contact_email = [blankError];
  if (!values.referral) formErrors.referral = [blankError];
  if (![true, false].includes(values.experienced))
    formErrors.experienced = [blankError];
  return formErrors;
};

export const secondPageValidations = (values) => {
  const formErrors = {};
  if (values.category_ids.length < 1)
    formErrors._error = 'You must select at least one category'; // eslint-disable-line no-underscore-dangle
  return formErrors;
};

export const alternateSecondPageValidations = (values) =>
  firstPageValidations(values);

export const categoryDetailValidations = (detail) => {
  const detailErrors = {};

  if (!detail.raw_call_count) detailErrors.raw_call_count = [blankError];
  if (!detail.billable_call_count)
    detailErrors.billable_call_count = [blankError];
  if (!detail.average_billable_call_payout)
    detailErrors.average_billable_call_payout = [blankError];
  if (detail.lead_generation_methods.length < 1)
    detailErrors.lead_generation_methods = [blankError];

  return detailErrors;
};

export const thirdPageValidations = (values) => {
  const formErrors = {};

  values.category_details.forEach((detail, i) => {
    const detailErrors = categoryDetailValidations(detail);

    if (!Object.keys(detailErrors).length <= 0) {
      if (!formErrors.category_details) {
        formErrors.category_details = [];
      }
      formErrors.category_details[i] = detailErrors;
    }
  });

  return formErrors;
};

export const fullValidations = (values) => ({
  ...firstPageValidations(values),
  ...secondPageValidations(values),
  ...thirdPageValidations(values)
});

const isDuplicatePartner = (errors) => {
  const {
    business_phone: businessPhone,
    primary_contact_email: primaryContactEmail
  } = errors;
  const hasDupError = (field) =>
    !!field.find((error) => error === 'has already been taken');

  if (businessPhone !== undefined && hasDupError(businessPhone)) return true;
  if (primaryContactEmail !== undefined && hasDupError(primaryContactEmail))
    return true;
  return false;
};

export const duplicatePartnerValidation = (values) => {
  const formErrors = {};
  if (!values.additional_information)
    formErrors.additional_information = [blankError];
  return formErrors;
};

export const asyncValidate = (values, dispatch) =>
  axios
    .get('/affiliate-contact/validate', {
      params: {
        access_token: accessTokenFromUrl(),
        business_phone: values.business_phone,
        country: values.country,
        primary_contact_email: values.primary_contact_email,
        state: values.state,
        zip_code: values.zip_code
      },
      headers: { 'Content-type': 'application/json' }
    })
    .then(
      () => {
        dispatch(setDuplicatePartner(false));
      },
      (errors) => {
        const validationErrors = errors.response.data.errors;
        dispatch(setDuplicatePartner(isDuplicatePartner(validationErrors)));
        throw validationErrors;
      }
    );
